import { RootState } from "@base/store";
import { identify, load } from "@base/utils/analytics";
import { profileActions } from "@components/features/profile/profile.slice";
import { Alert } from "@components/molecules/alert";
import Loader from "@components/molecules/loader";
import { PlanModal } from "@components/molecules/plan-modal";
import React from "react";
import CookieConsent from "react-cookie-consent";
import { usePromiseTracker } from "react-promise-tracker";
import { connect, useSelector } from "react-redux";

// FIXME:  add reduxProps to prop type
// type ReduxProps = ConnectedProps<typeof connector>;

const LoaderSnackbarWrapper = ({
  loaderVisible,
  snackBarMessage,
  snackBarVisible,
  snackBarType,
  isBlankLoader,
  cookieConsent,
  updateUser,
  hasUserExceededPlan,
}: any) => {
  const { promiseInProgress } = usePromiseTracker();
  const user = useSelector((state: RootState) => state.user.user);

  const handleEnableAdvertiserTracking = async () => {
    await updateUser({
      advertiser_tracking_enabled: true,
    });
  };

  return (
    <>
      <Loader
        loaderVisible={loaderVisible || promiseInProgress}
        isBlankLoader={promiseInProgress ? false : isBlankLoader}
      />
      <Alert
        isVisible={snackBarVisible}
        message={snackBarMessage}
        type={snackBarType}
      />
      {cookieConsent && (
        <CookieConsent
          location="bottom"
          buttonText="Allow"
          enableDeclineButton
          onAccept={(acceptedByScrolling) => {
            if (window.analytics && !window.analytics.initialized) {
              load();
            }
            identify(user);
            handleEnableAdvertiserTracking();
          }}
          onDecline={() => {}}
          declineButtonText="Decline"
          cookieName="ANCC"
          style={{ background: "#2B373B" }}
          buttonStyle={{ color: "#4e503b", fontSize: "13px" }}
          expires={150}
        >
          This website uses cookies to enhance the user experience.
        </CookieConsent>
      )}
      {<PlanModal />}
    </>
  );
};
const mapStateToProps = (state: RootState) => ({
  loaderVisible: state.globalAppearances?.loader,
  hasUserExceededPlan: state.user.hasUserExceededPlan,
  isBlankLoader: state.globalAppearances?.isBlankLoader,
  snackBarVisible: state.globalAppearances?.alert?.isVisible,
  snackBarMessage: state.globalAppearances?.alert?.message,
  snackBarType: state.globalAppearances?.alert?.type,
  cookieConsent: state.globalAppearances.cookieConsent,
});

const mapDispatchToProps = {
  updateUser: profileActions.updateUser,
};

const connector = connect(mapStateToProps, mapDispatchToProps);
const LoaderSnackbarWrapperRedux = connector(LoaderSnackbarWrapper);

export { LoaderSnackbarWrapperRedux as LoaderSnackbarWrapper };
